import React, { FC, useState, useEffect } from 'react'
import { ChevronDoubleRightIcon } from '@heroicons/react/outline'
import { useParams, useLocation } from 'react-router'
import { Button, Spinner } from '../../System'
import { CourseType, LessonType } from '../../../types'
import { getCourseCompletedPercentage } from '../../CourseLibraryView'
import { StyledLessonMap, LessonMapGroup } from '.'
import { useWindowSize } from '../../Grid'

type Props = {
  course: CourseType;
  currentLesson: LessonType;
  isOpen?: boolean;
  setLessonComplete(lesson: LessonType): void;
  setMapOpen: (bool: boolean) => void;
}

const LessonMap: FC<Props> = ({
  course, currentLesson, isOpen, setLessonComplete, setMapOpen
}) => {
  const { courseSlug }: any = useParams()
  const { pathname } = useLocation()
  const windowSize = useWindowSize()
  const bigScreen = ['md', 'lg'].includes(windowSize)
  const [completedPercentage, setCompletedPercentage] = useState(0)

  useEffect(() => {
    const percentComplete = getCourseCompletedPercentage(course)
    setCompletedPercentage(percentComplete)
  }, [JSON.stringify(course.modules)])

  useEffect(() => {
    if (!bigScreen) {
      setMapOpen(false)
    }
  }, [pathname])

  if (!course) {
    return <Spinner isBlock />
  }

  return (
    <StyledLessonMap isOpen={isOpen}>
      <div className="map-header">
        <Button
          className="menu-collapse-btn"
          onClick={() => setMapOpen(false)}
          theme="ghost"
          type="small"
          iconPos="left"
        >
          <ChevronDoubleRightIcon />
          Lessons
        </Button>
        <div className="completion-bar">
          <label htmlFor="course-progress">{completedPercentage.toFixed(0)}% Completed</label>
          <progress id="course-progress" max="100" value={completedPercentage}>
            {completedPercentage.toFixed(0)}%
          </progress>
        </div>
      </div>
      <div className="lesson-map">
        {course.modules &&
          course.modules.map((module, index) => {
            return (
              <LessonMapGroup
                module={module}
                currentLesson={currentLesson}
                courseSlug={courseSlug}
                setLessonComplete={setLessonComplete}
                key={index}
              />
            )
          })}
      </div>
    </StyledLessonMap>
  )
}

export default LessonMap
